import React from "react";

import { Grid as MuiGrid } from "@material-ui/core";

/**
 * Each Form Field is wrapped with a Grid Item, so this Grid container should be used inside Form to space the Fields out.
 */
export default function Grid({ children, ...props }) {
  return (
    <MuiGrid container spacing={2} {...props}>
      {children}
    </MuiGrid>
  );
}
